<template>
<div class="min-h-50" ref="searchResult" :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
  <div v-if="list !== null">
    <div class="BookList py-4 lg:py-6 xl:py-8 px-2 md:px-4 max-w-7xl mx-auto">
      <div class="main mx-auto">
        <div id="list-content--result" class="list-content list-content--normal">
          <p class="mb-1">您輸入的關鍵字: "<span class="textColorRed text-NotoSansBold">{{ $route.query.keyword }}</span>"</p>
          <p class="text-sm text-gray-700 mb-1">搜尋結果共計<span class="font-bold" v-if="list.data">{{ list.total ? list.total : 0 }}</span>筆</p>

          <!-- <p class="list-info-result text-center text-2xl md:text-3xl mb-2 md:mb-3">
            "<span class="textColorRed text-NotoSansBold">{{ $route.query.keyword }}</span>"
          </p>
          <p class="text-center mb-4  md:mb-10 text-sm text-NotoSansRegular">搜尋結果共計
            <span class="font-bold" v-if="list.data">{{ list.total ? list.total : 0 }}</span>筆，按此
            <router-link class="cursor-pointer textColorRed" :to="{ name: 'index' }">返回</router-link>首頁
          </p> -->

          <div class="flex flex-wrap justify-end text-sm mb-3">
            <div class="relative">
              <select v-model="selectSort"
                class="border block appearance-none w-full  text-gray-700 py-2 px-2 pr-6 rounded leading-tight focus:outline-none bg-white focus:border-gray-500 text-sm">
                  <option value="published_at">出版日期由新→舊</option>
                  <option value="published_at_old">出版日期由舊→新</option>
                  <option value="price_up">價格由低→高</option>
                  <option value="price_down">價格由高→低</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>

            <div class="relative">
              <select v-model="selectType"
                class="border block appearance-none w-full  text-gray-700 py-2 px-2 pr-6 rounded leading-tight focus:outline-none bg-white focus:border-gray-500 text-sm">
                  <option value="">不分類</option>
                  <option value="MAGAZINE">雜誌/不分類</option>
                  <option value="MAGAZINE,PHYSICAL">雜誌/紙本零售</option>
                  <option value="MAGAZINE,DIGITAL">雜誌/軟體零售</option>
                  <option value="BOOK">書籍</option>
                  <option value="PACKAGE">套書</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
            <button class="button-red py-2 px-3 rounded text-white w-auto" @click="getData2">
              篩選
            </button>
          </div>

          <div class="flex flex-wrap">
            <div class="w-1/2 md:w-1/3 lg:w-1/4 mb-4 flex-shrink" v-for="(item, index) in list.data" :key="index"
              >
              <ProductModule :data="list.data[index]" v-on:refreash="refreash" />
            </div>
          </div>
        </div>
      </div>

    </div>

    <PaginateComponent :pagination="pagination" v-on:pageChangeHandler="pageChangeHandler" />

  </div>
  <div v-else class="pt-8">
    <img src="~@/assets/icon/Pulse.gif" class="mx-auto h-12">
  </div>
</div>
</template>
<!-- eslint-disable no-unused-expressions -->
<script>
import axios from 'axios'
import Cart from '@/components/modules/addCart'
import ProductModule from '@/components/product/ProductModule'
import PaginateComponent from '@/components/modules/Paginatation'
import jump from 'jump.js'
import advertising from '@/components/modules/advertising'
export default {
  name: 'SearchResult',
  metaInfo () {
    return {
      title: this.page_title
    }
  },
  data () {
    return {
      page_title: '',

      list: null,

      selectSort: 'published_at',
      selectType: '',

      // pagination
      pageSize: 40,
      pagination: {
        currentPage: 1,
        length: 5
      }
    }
  },
  mixins: [
    Cart,
    advertising
  ],
  components: {
    ProductModule,
    PaginateComponent
  },
  watch: {
    '$route.query': {
      handler (query, oldQuery) {
        if (query.keyword !== oldQuery.keyword) {
          this.getData()
        }
      }
    }
  },
  computed: {
    keyword () {
      return this.$route.query.keyword
    },
    updatedSort (val) {
      let self = this

      let dataObj = {}
      switch (self.selectSort) {
        case 'published_at':
          // 出版日期由新→舊
          dataObj.sort = 'published_at'
          dataObj.sortBy = 'desc'
          break
        case 'published_at_old':
          // 出版日期由舊→新
          dataObj.sort = 'published_at'
          dataObj.sortBy = 'asc'
          break
        case 'price_up':
          // 價格由低→高
          dataObj.sort = 'pricing'
          dataObj.sortBy = 'asc'
          break
        case 'price_down':
          // 價格由高→低
          dataObj.sort = 'pricing'
          dataObj.sortBy = 'desc'
          break
      }

      return dataObj
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      let self = this
      let dataObj = {
        params: {
          query: self.$route.query.keyword,
          pageSize: self.pageSize,
          page: self.pagination.currentPage,
          // sortBy: 'published_at',
          ...self.updatedSort
        }
      }

      await axios.get('/products', dataObj)
        .then((response) => {
          self.page_title = self.$route.query.keyword
          self.list = response.data
          self.pagination.length = response.data.last_page
          self.$nextTick(() => {
            jump(self.$refs.searchResult, {
              duration: 0,
              offset: -150
            })
          })
          self.searchCode(self.$route.query.keyword, response.data.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async getData2 () {
      let self = this
      let dataObj = {
        params: {
          query: self.$route.query.keyword,
          pageSize: self.pageSize,
          page: self.pagination.currentPage,
          // sortBy: 'published_at',
          ...self.updatedSort
        }
      }

      self.selectType ? dataObj.params.type = self.selectType : null

      console.log(dataObj)

      await axios.get('/products', dataObj)
        .then((response) => {
          self.page_title = self.$route.query.keyword
          self.list = response.data
          self.pagination.length = response.data.last_page
          self.$nextTick(() => {
            jump(self.$refs.searchResult, {
              duration: 0,
              offset: -150
            })
          })
          self.searchCode(self.$route.query.keyword, response.data.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async pageChange (pageNum) {
      let self = this
      self.pagination.currentPage = pageNum
      self.getData()
    },

    async pageChangeHandler (pageChangeHandler) {
      let self = this
      self.pagination.currentPage = pageChangeHandler
      self.getData()
    },

    refreash (refreash) {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .BookList {
    min-height: 60vh;
  }
  .controls-item {
    input[type="checkbox"] {
      box-sizing: border-box;
      padding: 0;
      margin-right: .4em;
      width: 100%;
      margin-bottom: 10px;
      &:hover + label:before {
        background: #e6e6e6;
      }
    }
    label {
      position: relative;
      display: inline-block;
      padding-left: 16px;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      vertical-align: middle;
    }

    label:before {
      content: '';
      display: inline-block;
      position: absolute;
      top: 8px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      width: 12px;
      height: 12px;
      border: 1px solid #6c6c6c;
      left: 0;
      transition: .2s;
    }
    .labelisTrue:hover + label:before {
      background: #ffffff !important;
    }
    .labelisTrue + label:after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 11px;
      background-color: #383838;
      width: 6px;
      height: 6px;
      left: 3px;
    }
    span {
      line-height: 18px;
    }
  }
</style>
